import { PATIENTS_IN_QUEUE, DOCTORS_IN_QUEUE } from "../constants/queueCount";

const initialState = {
  patientsInQueue: 0,
  doctorsOnline: {
    connectedDoctors: [],
    icDoctorCount: 0
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case PATIENTS_IN_QUEUE:
      return {
        ...state,
        patientsInQueue: action.payload
      };
    case DOCTORS_IN_QUEUE:
      return {
        ...state,
        doctorsOnline: action.payload
      };
    default:
      return state;
  }
}
